import { useQuery } from "@tanstack/react-query";
import { listPublicationRequests, type PublicationRequestStatus } from "../api/publicationRequestsApi";

export function usePublicationRequests(status?: PublicationRequestStatus) {
  return useQuery({
    queryKey: ["publication-requests", status ?? "all"],
    queryFn: () => listPublicationRequests(status),
  });
}
